import { defineStore } from 'pinia';
import { carReviewGetters } from './getters';
import { ICarReviewStoreState } from '../../interfaces/ICarReviewStoreState';
import { carAdvisoryService } from '../../apiCarAdvisoryService';
import { ISearchReviewDocument } from '../../interfaces/IReviewSearchResult';
import { IExpertReviewPayload } from '../../interfaces/IExpertReview';
import { hasStoreContentExpired } from '../../../foundation/helpers';

export const useCarReviewStore = defineStore('carReviewStore', {
  state: (): ICarReviewStoreState => ({
    reviews: [] as ISearchReviewDocument[],
    storedReviews: [] as IExpertReviewPayload[],
    storeLastRefreshed: '', //the datetime when store has been last reset - cache cleared
  }),
  actions: {
    async searchReviewByMakeAndModel(make: string, model: string) {
      if (!make) return [];
      const reviews = this.reviews?.filter((x) => x.make == make.toLowerCase() && x.model == model.toLowerCase())[0]?.reviews;
      if (reviews != null) return;
      const requestBody = {
        filter: {
          op: 'and',
          children: [
            {
              field: 'vehicle_make',
              eq: [make.toLowerCase()],
            },
            {
              field: 'vehicle_model',
              eq: [model.toLowerCase()],
            },
          ],
        },
        includeTotalCount: true,
        count: 100,
        skip: 0,
        //this will be fixed once API is working
        fields: [
          'vehicle_uid',
          'review_id',
          'mobility_club',
          'vehicle_model_year',
          'vehicle_make',
          'vehicle_model',
          'vehicle_trim',
          'vehicle_model_correct_case',
          'vehicle_make_correct_case',
          'vehicle_trim_correct_case',
          'date_of_car_review',
        ],
      };

      var result = await carAdvisoryService.fetchVehiclesReviewsBySearch(requestBody);
      const reviewResult: ISearchReviewDocument = { make: make.toLowerCase(), model: model.toLowerCase(), reviews: result.results };
      if (result) this.reviews.push(reviewResult);
    },
    async fetchReviewById(reviewId: string) {
      let reviewExists = false;
      this.storedReviews.forEach((review) => {
        if (review?.reviews) {
          review.reviews.forEach((currReview) => {
            if (currReview.id == reviewId) reviewExists = true;
          });
        }
      });
      if (!reviewExists) {
        const expReviewData: IExpertReviewPayload = await carAdvisoryService.fetchReviewsById(reviewId);
        this.storedReviews.push(expReviewData);
      }
    },
    /**
     * If store needs to be refresh because of the expiry time
     * @param numberOfHoursForStoreContentToExpire
     */
    resetStoreCache(numberOfHoursForStoreContentToExpire: number) {
      if (this.storeLastRefreshed) {
        // if last updated date is set in the store
        const hasContentExpired = hasStoreContentExpired(this.storeLastRefreshed, numberOfHoursForStoreContentToExpire);
        if (hasContentExpired) {
          // sif last updated time + config hours in less than current system datetime - then store require updating
          console.log('Store content refreshed => Car Comparison store');
          this.$reset();
          this.storeLastRefreshed = new Date().toString();
        }
      } else {
        console.log('Setting last updated on store => Car Comparison store');
        this.storeLastRefreshed = new Date().toString();
      }
    },
  },
  getters: { ...carReviewGetters },
  persist: true,
});
